import React, { useEffect, useState } from "react";
import StudentTopMenu from "./studenttopmenu";
import { useParams } from "react-router-dom";
import StudentInfoBox from "./studentinfobox";
import GlobalStudentLesson from "../../pages/common/globalstudentlessonforgrade";
import { useAuth } from "../../../usercontext";
import Student911TopMenu from "../studentInfo/student911topmenu"
//import GlobalStudentLesson2 from "../../pages/common/globalstudentlesson2";
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu";

export default function InstructorStudentLessonForGrade() {
  const { profile, setProfile } = useAuth();
    let { slug } = useParams();
    const [isStudent911, setisStudent911] = useState(false);
    const [isStudent12, setisStudent12] = useState(false);

      async function GetData() {
        const info = await getIdData(slug);
        if (info[0].role === "Student911") {
          setisStudent911(true);
        } else if (info[0].role === "Student12") {
          setisStudent12(true);
        }
      }
       
        useEffect(() => {
          GetData();
        }, []);

  return (
    <>
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
                {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"GradeList"} /> }
                {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"GradeList"} /> }
            <GlobalStudentLesson slug={slug} isStudent={false} /> 
            
          </div>
        </div>
      </div>
    </>
  );
}
